/// <reference path="../../../tools/typings/angularjs/angular.d.ts"/>


// @TODO: some cases of user pasting with text selected don't work quite as you would expect.
//
module DealerwareWebComponents {

    "use strict";

    export interface IDirectiveScope extends ng.IScope {
        allowedPattern  : string;
        transform       : any;
        inputStarted    : any;
        filterNonCharacters: boolean;
    }


    // Provides input formatting as the user types, base on specific callbacks.
    //
    export class InputFormatterDirective implements ng.IDirective {

        public restrict     : string = 'A';
        public replace      : boolean = false;
        public scope        : Object = {
            allowedPattern  : '@?inputFormatterAllowedInput',
            transform       : '&?inputFormatterTransform',
            inputStarted    : '&?inputFormatterInputStarted',
            filterNonCharacters: '=?inputFormatterFilterNonCharacters'
        };
        public transclude   : boolean = false;

        public static $inject:string[] = [ ];

        constructor () {

        }

        public restrictToPattern ( event: any, pattern: RegExp ) : void {

            // Paste event vs. regular single character input are the two ways
            // we're receiving text entry, and to be safe, translate charCode value --
            // rather than using the more pleasing event.result -- because apparently
            // MSIE doesn't seem to support it.
            //
            var attemptedInput = event.type === 'paste' ?
                event.originalEvent.clipboardData.getData('text/plain') :
                ( String.fromCharCode(event.charCode) === undefined ? '' :
                    String.fromCharCode(event.charCode)
                );

            var elem  = event.currentTarget;
            var value = elem.value;

            // Trickiness takes into account a text selection, if any, in determining
            // what the user is trying to put in this text field.
            //
            var proposedInputValue = value.substring(0, elem.selectionStart) +
                  attemptedInput +
                  value.substring(elem.selectionEnd, value.length);

            //console.info('Attempted key/paste : event.type : ', event.type, 'keyCode', event.keyCode, 'charCode', event.charCode);

            // Test input to see if it matches the given pattern (more properly, the entire input)
            // or else block the event.
            //
            if (! pattern.test(proposedInputValue)) {
                //console.info('DENIED', event.currentTarget.value, proposedInputValue, attemptedInput, event.type, 'keyCode', event.keyCode, 'charCode', event.charCode);
                event.stopPropagation();
                event.preventDefault();
            }
        }

        public link:ng.IDirective = (
            scope   : IDirectiveScope,
            element : ng.IAugmentedJQuery
        ) => {

            var that = this;

            var patternTransform = scope.transform
                && typeof scope.transform === 'function'
                && scope.transform();
            var transformArgs = patternTransform && patternTransform.args || { };

            // Sets up keystroke events.  You wouldn't believe how hard this would've been in
            // the early Mozilla days.  'input' event anyone?
            //
            if (scope.allowedPattern !== undefined) {

                element.bind('keypress paste', (event: any) => {

                    // @TODO: keypress allowed characters needs to be understood
                    //        more fully, this list doesn't work 100% of the time,
                    //        e.g. opt-e then opt-q
                    //
                    if (scope.filterNonCharacters || transformArgs.filterNonCharacters) {

                        var avoidValidationKeycodes = [

                            // These keypress events are fired for all browsers.
                            //
                            13,     //return key
                            //0,     // not a key


                            // These keypress events are only fired for Mozilla, but still
                            // we shouldn't disallow them.
                            //
                            9,      // tab
                            37,     // left arrow
                            39,     // right arrow
                            38,     // up arrow
                            40,     // down arrow
                            8       // backspace/delete
                        ];

                        if ( avoidValidationKeycodes.indexOf(event.keyCode) !== -1
                             && event.keyCode !== event.charCode
                           ) {
                            //console.info('0a: keypress/paste : special key detected, avoid validity check', 'keyCode', event.keyCode, '(charCode = ' + event.charCode + ')')
                            return;
                        }
                        else {
                            //console.info('0b: keypress/paste : special key not detected, VALIDATE', 'keyCode', event.keyCode, '(charCode = ' + event.charCode + ')')
                        }
                    }

                    // Canned filters.  Format examples:
                    //
                    //     input-formatter-allowed-input="alphanumeric(255)"
                    //         - Allowed: A through Z, upper and lower case, and 0-9, allowed length > 0 <= 255.
                    //     input-formatter-allowed-input="numeric(5,7)"
                    //         - Allowed: 0-9, between 5 and 7 characters inclusive.  Since the keystroke must input
                    //           at least 5 characters, which is only possible if you paste in 5 characters,
                    //           this mode might not be all that useful lol.
                    //     input-formatter-allowed-input="alpha"
                    //         - Allowed: Alphabetic characters, no limit.
                    //
                    var match = scope.allowedPattern.match(/^(alpha)?(numeric)?(?:\((\d+)(,\d+)?\))?$/)
                    if (match) {
                        var allowedPattern = '^';

                        var allowedAlphanumPattern = '[';
                        if (match[1] !== undefined) {
                            allowedAlphanumPattern += 'A-Za-z';
                        }
                        if (match[2] !== undefined) {
                            allowedAlphanumPattern += '0-9';
                        }

                        // One or more character classes.
                        //
                        if (allowedAlphanumPattern.length > 1) {
                            allowedPattern += allowedAlphanumPattern + ']';

                            // Limits placed on the number of allowed characters.
                            //
                            if (match[3] !== undefined || match[4] !== undefined) {
                                var lengthRange = match[4] === undefined ? '0,' + match[3] :
                                    match[3] + match[4];
                                allowedPattern += '{' + lengthRange + '}';
                            }
                            // Or not.
                            //
                            else {
                                allowedPattern += '*';
                            }
                        }
                        else {
                            // If none of the previous two conditions above matched, but there was still
                            // some match, (i.e. the range numbers only), a zero character matchable regex
                            // will result (^$).
                            //
                        }

                        allowedPattern += '$';
                    }
                    else {
                        allowedPattern = scope.allowedPattern;
                    }

                    // Restrict input.
                    //
                    that.restrictToPattern (event, new RegExp(allowedPattern));
                });
            }

            if (patternTransform) {

                element.bind('keyup', (event: any) => {

                    // Always allow: backspace, left/right arrows.
                    //
                    if (transformArgs.filterNonCharacters) {

                        // Formatting will be fired except for keys in this list.  Note that if
                        // transformArgs.formatEvent is set to something other than the default 'keyup',
                        // the event to fire the transform will occur at a different time, rather than
                        // right after this keyup handler code.
                        //
                        // This means that pressing any of these keys won't really be relevant the input field
                        // formatting.  The list should be fairly exhaustive, but there are some keys which
                        // may not be handled perfectly.
                        //
                        // i.e. if formatEvent === 'blur', the text will be run through the formatter to calculate
                        // formatted values, if any, regardless of whether any of these keys are pressed.
                        //
                        // http://www.javascripter.net/faq/keycodes.htm
                        //
                        var checkForBypassFormatting = ( keyCode : number ) => {

                            // Not a key, strangely fires in this handler sometimes.
                            //
                            if (keyCode === 0) {
                                return true;
                            }

                            // Shift, ctrl, option/alt, pause, break, caps lock
                            //
                            if (keyCode >= 16 && keyCode <= 20) {
                                return true;
                            }

                            // Page up, page down, end, home
                            //
                            if (keyCode >= 33 && keyCode <= 36) {
                                return true;
                            }

                            // Arrow keys
                            //
                            if (keyCode >= 37 && keyCode <= 40) {
                                return true;
                            }

                            // Insert, delete, backspace
                            //
                            if (keyCode >= 45 && keyCode <= 46 || keyCode === 8) {
                                return true;
                            }

                            // Windows: start, menu
                            //
                            if (keyCode === 91 || keyCode === 93) {
                                return true;
                            }

                            // Function keys
                            //
                            if (keyCode >= 112 && keyCode <= 123) {
                                return true;
                            }

                            // NumLock, scrollLock
                            //
                            if (keyCode === 144 || keyCode === 155) {
                                return true;
                            }

                            return false;
                        }

                        if (checkForBypassFormatting(event.keyCode)) {
                            //console.info('1a: keyup : special key detected, avoid formatting', 'keyCode', event.keyCode, '(charCode = ' + event.charCode + ')')
                            event.bypassFormatting = true;
                        }
                        else {
                            //console.info('1b: keyup : special key not detected, FORMAT', 'keyCode', event.keyCode, '(charCode = ' + event.charCode + ')')
                        }
                    }
                });

                // transformArgs.formatEvent ||
                element.bind(transformArgs.formatEvent || 'keyup', (event: any) => {

                    //console.info('2a: transform, check?', event.bypassFormatting);

                    if (event.bypassFormatting) {
                        return;
                    }

                    // Transform text, if input-formatter-transform element directive
                    // attribute is set.
                    //
                    var transformedText = patternTransform.formatter
                        && patternTransform.formatter(element.val());
                    //console.info('2a: transform, checking for', transformedText)
                    if (transformedText !== undefined && transformedText !== null) {
                        //console.info('3: transform, DOING', transformedText)
                        element.val(transformedText);
                    }
                });
            }

            if (scope.inputStarted && typeof scope.inputStarted === 'function') {

                var inputStartedTransform = scope.inputStarted();

                element.bind('focus', (event: any) => {

                    // Always allow: backspace, left/right arrows.
                    //
                    if (typeof inputStartedTransform.args === 'object' && inputStartedTransform.args.filterNonCharacters) {

                        // @TODO: in light of the above commentary on key/char codes, is this right?
                        //
                        var allowedCharCodes = [8, 37, 39];
                        if (allowedCharCodes.indexOf(event.keyCode) !== -1) {
                            return;
                        }
                    }

                    // Transform text, if input-formatter-transform element directive
                    // attribute is set.
                    //
                    var transformedText = patternTransform.formatter(element.val());
                    if (transformedText !== undefined && transformedText !== null) {
                        element.val(transformedText);
                    }
                });
            }
        }
    }

    getDealerwareWebComponentsModule().directive(
        'inputFormatter',
        ( ) => new InputFormatterDirective ()
    );


    export class RigorousEmailValidationDirective implements ng.IDirective {

        public restrict         : string    =   'A';
        public replace          : boolean   =   false;
        public require          : string    =   'ngModel';
        public static $inject   : string[]  =   [ 'DataUtils' ];

        public dataUtils        : any;

        constructor(
            public DataUtils: any
        ) {
            this.dataUtils = this.DataUtils.getInstance();
        }

        public link : ng.IDirectiveLinkFn = (
            scope   :   ng.IScope,
            element :   ng.IAugmentedJQuery,
            attrs   :   ng.IAttributes,
            ctrls   :   any
        ) => {

            var that = this;

            ctrls.$validators.format = function (modelValue: any, viewValue: any) {

                // Let required pick up the error, or blank is ok.
                //
                if (that.dataUtils.isBlank(viewValue)) {
                    return true;
                }

                // Note: this badboy regex forbids a few types of technically valid
                // email addresses such as:
                //
                //    a@b   <-- e.g. yo_momma@localhost (not useful, if entered it's
                //              almost certainly a PEBKAC*);
                //    a@b.c <-- nothing forbidden in the various RFCs regarding one-letter TLDs,
                //              but if entered, it's probably also a PEBKAC.
                //
                //        * Problem Exists Between Keyboard And Chair, i.e. user error.
                //
                return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(viewValue);
            };
        }
    }

    getDealerwareWebComponentsModule().directive(
        'rigorousEmailValidation',
        ( DataUtils: any ) => new RigorousEmailValidationDirective (DataUtils)
    );


    // Lenient license plate validation, starts with one or more alphanums, may have
    // a dash, then ends with one or more alphanums.  Doesn't implement by-state
    // allowed license plate serial formats, lol.
    //
    export class UsLicensePlateValidationDirective implements ng.IDirective {

        public restrict         : string    =   'A';
        public replace          : boolean   =   false;
        public require          : string    =   'ngModel';
        public static $inject   : string[]  =   [ 'DataUtils' ];

        public dataUtils        : any;

        constructor(
            public DataUtils: any
        ) {
            this.dataUtils = this.DataUtils.getInstance();
        }

        public link : ng.IDirectiveLinkFn = (
            scope   :   ng.IScope,
            element :   ng.IAugmentedJQuery,
            attrs   :   ng.IAttributes,
            ctrls   :   any
        ) => {

            var that = this;

            ctrls.$validators.format = function (modelValue: any, viewValue: any) {

                // Let required pick up the error, or blank is ok.
                //
                if (that.dataUtils.isBlank(viewValue)) {
                    return true;
                }

                return new RegExp ('^[A-Za-z0-9]+\\-?[A-Za-z0-9]+$').test(viewValue || '');
            };
        }
    }

    getDealerwareWebComponentsModule().directive(
        'usLicensePlateValidation',
        ( DataUtils: any ) => new UsLicensePlateValidationDirective (DataUtils)
    );


    // Plain old US phone number: (nnn) nnn-nnnn.  Spaces and parens are optional.
    //
    export class UsPhoneValidationDirective implements ng.IDirective {

        public restrict         : string    =   'A';
        public replace          : boolean   =   false;
        public require          : string    =   'ngModel';
        public static $inject   : string[]  =   [ 'DataUtils' ];

        public dataUtils        : any;

        constructor(
            public DataUtils: any
        ) {
            this.dataUtils = this.DataUtils.getInstance();
        }

        public link : ng.IDirectiveLinkFn = (
            scope   :   ng.IScope,
            element :   ng.IAugmentedJQuery,
            attrs   :   ng.IAttributes,
            ctrls   :   any
        ) => {

            var that = this;

            ctrls.$validators.format = function (modelValue: any, viewValue: any) {

                // Let required pick up the error, or blank is ok.
                //
                if (that.dataUtils.isBlank(viewValue)) {
                    return true;
                }

                return new RegExp ('^\\(?\\d{3}\\)? ?\\d{3}\\-?\\d{4}$').test(viewValue || '');
            };
        }
    }

    getDealerwareWebComponentsModule().directive(
        'usPhoneValidation',
        ( DataUtils: any ) => new UsPhoneValidationDirective (DataUtils)
    );


    // Plain old SSN: nnn-nn-nnnn.  I'm lazy, only these are valid:
    //
    //   https://www.ssa.gov/employer/stateweb.htm
    //
    // but more might be added.
    //
    export class SsnValidationDirective implements ng.IDirective {

        public restrict         : string    =   'A';
        public replace          : boolean   =   false;
        public require          : string    =   'ngModel';
        public static $inject   : string[]  =   [ 'DataUtils' ];

        public dataUtils        : any;

        constructor(
            public DataUtils: any
        ) {
            this.dataUtils = this.DataUtils.getInstance();
        }

        public link : ng.IDirectiveLinkFn = (
            scope   :   ng.IScope,
            element :   ng.IAugmentedJQuery,
            attrs   :   ng.IAttributes,
            ctrls   :   any
        ) => {

            var that = this;

            ctrls.$validators.format = function (modelValue: any, viewValue: any) {

                // Let required pick up the error, or blank is ok.
                //
                if (that.dataUtils.isBlank(viewValue)) {
                    return true;
                }

                return attrs['ssnValidation'] ?
                    new RegExp ('^[\\*\\d]{3}\-[\\*\\d]{2}\-\\d{4}$').test(viewValue || '') :
                    new RegExp ('^\\d{3}\-?\\d{2}\-?\\d{4}$').test(viewValue || '');
            };
        }
    }

    getDealerwareWebComponentsModule().directive(
        'ssnValidation',
        ( DataUtils: any ) => new SsnValidationDirective (DataUtils)
    );


    // See EIN/TIN format specs at:
    //
    //   https://en.wikipedia.org/wiki/Employer_Identification_Number
    //
    export class EinValidationDirective implements ng.IDirective {

        public restrict         : string    =   'A';
        public replace          : boolean   =   false;
        public require          : string    =   'ngModel';
        public static $inject   : string[]  =   [ 'DataUtils' ];

        public dataUtils        : any;

        constructor(
            public DataUtils: any
        ) {
            this.dataUtils = this.DataUtils.getInstance();
        }

        public link : ng.IDirectiveLinkFn = (
            scope   :   ng.IScope,
            element :   ng.IAugmentedJQuery,
            attrs   :   ng.IAttributes,
            ctrls   :   any
        ) => {

            var that = this;

            ctrls.$validators.format = function (modelValue: any, viewValue: any) {

                // Let required pick up the error, or blank is ok.
                //
                if (that.dataUtils.isBlank(viewValue)) {
                    return true;
                }

                var irsCampusCodes = [
                    '10', '12', '60', '67', '50', '53', '01', '02', '03', '04', '05', '06',
                    '11', '13', '14', '16', '21', '22', '23', '25', '34', '51', '52', '54',
                    '55', '56', '57', '58', '59', '65', '30', '32', '35', '36', '37', '38',
                    '61', '15', '24', '40', '44', '94', '95', '80', '90', '33', '39', '41',
                    '42', '43', '48', '62', '63', '64', '66', '68', '71', '72', '73', '74',
                    '75', '76', '77', '82', '83', '84', '85', '86', '87', '88', '91', '92',
                    '93', '98', '99', '20', '26', '27', '45', '46', '47', '81'
                ];

                return new RegExp ('^(?:' + irsCampusCodes.join('|') + ')\\-?(\\d{7})$')
                    .test(viewValue || '');
            };
        }
    }

    getDealerwareWebComponentsModule().directive(
        'einValidation',
        ( DataUtils: any ) => new EinValidationDirective (DataUtils)
    );


    // See MICR format specs at:
    //
    //   https://en.wikipedia.org/wiki/Routing_transit_number
    //
    export class BankRoutingMicrValidationDirective implements ng.IDirective {

        public restrict         : string    =   'A';
        public replace          : boolean   =   false;
        public require          : string    =   'ngModel';
        public static $inject   : string[]  =   [ 'DataUtils' ];

        public dataUtils        : any;

        constructor(
            public DataUtils: any
        ) {
            this.dataUtils = this.DataUtils.getInstance();
        }

        public link : ng.IDirectiveLinkFn = (
            scope   :   ng.IScope,
            element :   ng.IAugmentedJQuery,
            attrs   :   ng.IAttributes,
            ctrls   :   any
        ) => {

            var that = this;

            ctrls.$validators.format = function (modelValue: any, viewValue: any) {

                // Let required pick up the error, or blank is ok.
                //
                if (that.dataUtils.isBlank(viewValue)) {
                    return true;
                }

                // Allowed Federal Reserve Bank digits for first 2 numbers.
                //
                if (! /^(?:0[1-9]|1[0-2]|2[1-9]|3[0-2]|6[1-9]|7[0-2])\d{7}$/.test(viewValue)) {
                    return false;
                }

                // Numbers 3-8 are unrestricted, then a checksum at position 9.
                //
                //   3(d1 + d4 + d7) + 7(d2 + d5 + d8) + (d3 + d6 + d9) => mod 10 == 0.
                //
                var checkSum = 3 * ( parseInt(viewValue.charAt(0), 10)
                                     + parseInt(viewValue.charAt(3), 10)
                                     + parseInt(viewValue.charAt(6), 10)
                                   )
                             + 7 * ( parseInt(viewValue.charAt(1), 10)
                                     + parseInt(viewValue.charAt(4), 10)
                                     + parseInt(viewValue.charAt(7), 10)
                                   )
                             + 1 * ( parseInt(viewValue.charAt(2), 10)
                                     + parseInt(viewValue.charAt(5), 10)
                                     + parseInt(viewValue.charAt(8), 10)
                                   )
                return checkSum % 10 === 0;
            };
        }
    }

    getDealerwareWebComponentsModule().directive(
        'bankRoutingMicrValidation',
        ( DataUtils: any ) => new BankRoutingMicrValidationDirective (DataUtils)
    );


    // This is just the brain-dead US version, not IBAN.
    //
    export class BankAccountValidationDirective implements ng.IDirective {

        public restrict         : string    =   'A';
        public replace          : boolean   =   false;
        public require          : string    =   'ngModel';
        public static $inject   : string[]  =   [ 'DataUtils' ];

        public dataUtils        : any;

        constructor(
            public DataUtils: any
        ) {
            this.dataUtils = this.DataUtils.getInstance();
        }

        public link : ng.IDirectiveLinkFn = (
            scope   :   ng.IScope,
            element :   ng.IAugmentedJQuery,
            attrs   :   ng.IAttributes,
            ctrls   :   any
        ) => {

            var that = this;

            ctrls.$validators.format = function (modelValue: any, viewValue: any) {

                // Let required pick up the error.
                //
                if (that.dataUtils.isBlank(viewValue)) {
                    return true;
                }

                // Relies on arbitrary 8 character mask set in DataUtils.normalizeBankAccountFromLastFour.
                //
                return attrs['bankAccountValidation'] ?
                    /^[\d\*]{6,17}$/.test(viewValue) :
                    /^\d{6,17}$/.test(viewValue);
            };
        }
    }

    getDealerwareWebComponentsModule().directive(
        'bankAccountValidation',
        ( DataUtils: any ) => new BankAccountValidationDirective (DataUtils)
    );


    export class RigorousUrlValidationDirective implements ng.IDirective {

        public restrict         : string    =   'A';
        public replace          : boolean   =   false;
        public require          : string    =   'ngModel';
        public static $inject   : string[]  =   [ 'DataUtils' ];

        public dataUtils        : any;

        constructor(
            public DataUtils: any
        ) {
            this.dataUtils = this.DataUtils.getInstance();
        }

        public link : ng.IDirectiveLinkFn = (
            scope   :   ng.IScope,
            element :   ng.IAugmentedJQuery,
            attrs   :   ng.IAttributes,
            ctrls   :   any
        ) => {

            var that = this;

            ctrls.$validators.format = function (modelValue: any, viewValue: any) {

                // Let required pick up the error, or blank is ok.
                //
                if (that.dataUtils.isBlank(viewValue)) {
                    return true;
                }

                var secureS = attrs['rigorousUrlValidation'] === 'secure' ? '' : '?'
                var urlRegex = new RegExp(
                    '^https' + secureS
                    + '://([0-9A-Za-z-\\.@:%_\\+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?'
                );

                return urlRegex.test(viewValue);
            };
        }
    }

    getDealerwareWebComponentsModule().directive(
        'rigorousUrlValidation',
        ( DataUtils: any ) => new RigorousUrlValidationDirective (DataUtils)
    );


    export interface ICurrencyFormatterScope extends ng.IScope {
        currencySymbol: string;
    }

    export class SimpleCurrencyFormatter implements ng.IDirective {
        public restrict         : string    =   'A';
        public replace          : boolean   =   false;
        public require          : string    =   'ngModel'
        public scope            : Object    =   { currencySymbol: '@?currencySymbol' };
        public static $inject   : string[]  =   ['$filter'];

        constructor(public $filter: any) {}

        public link : ng.IDirectiveLinkFn = (
            scope   :   ICurrencyFormatterScope,
            element :   ng.IAugmentedJQuery,
            attrs   :   ng.IAttributes,
            ctrls   :   any
        ) => {
            ctrls.$parsers.push((viewValue: any) => {
                if (!viewValue) return '';

                var regex = new RegExp('[^' + scope.currencySymbol + '0-9.]+', 'g'),
                    parsedValue = viewValue.replace(regex, '');

                if (parsedValue !== viewValue) {
                    ctrls.$setViewValue(parsedValue);
                    ctrls.$render();
                }
                return parsedValue.replace(/[^0-9.]+/g, '');
            });

            ctrls.$formatters.unshift(() => {
                scope.currencySymbol = scope.currencySymbol || '$';
                return this.$filter('customCurrency')(ctrls.$modelValue);
            });

            element.bind('blur', () => {
                var plainNumber = element.val().replace(/[^\d|\-+|\.+]/g, '');
                scope.currencySymbol = scope.currencySymbol || '$';
                element.val(this.$filter('customCurrency')(parseFloat(plainNumber)));
            });
        }
    }

    getDealerwareWebComponentsModule().directive('currency', ($filter: any) => new SimpleCurrencyFormatter($filter));

    export class SimplePercentageFormatter implements ng.IDirective {
        public restrict         : string    =   'A';
        public replace          : boolean   =   false;
        public require          : string    =   'ngModel'
        public static $inject   : string[]  =   ['$filter'];

        constructor(public $filter: any) {}

        public link : ng.IDirectiveLinkFn = (
            scope   :   ng.IScope,
            element :   ng.IAugmentedJQuery,
            attrs   :   ng.IAttributes,
            ctrls   :   any
        ) => {
            ctrls.$parsers.push((viewValue: any) => {
                if (!viewValue) return '';

                var parsedValue = viewValue.replace(/[^\d+\.?\d*%?$]/gi, '');

                if (parsedValue !== viewValue) {
                    ctrls.$setViewValue(parsedValue);
                    ctrls.$render();
                }

                return parsedValue.replace(/[^0-9.]+/g, '');
            });

            ctrls.$formatters.push(() => {
                if (!ctrls.$modelValue) return '';
                return this.$filter('percentage')(ctrls.$modelValue / 100);
            });

            element.bind('blur', () => {
                if (!element.val()) return;
                var plainNumber = element.val().replace(/[^\d|\-+|\.+]/g, '');
                element.val(this.$filter('percentage')(parseFloat(plainNumber) / 100));
            });
        }
    }

    getDealerwareWebComponentsModule().directive('percentage', ($filter: any) => new SimplePercentageFormatter($filter));
}
